import React, { Component } from 'react';
import Constants from '../../../definitions/constants';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import toastr from 'toastr';
import { intl } from '../../../locales/localesConfig';

import Select from '../common/inputs/select';
import TextBox from '../common/inputs/textBox';

class BiTemplatesDataObject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAllTextInObjects: true,
    };
  }
  
  handleOnChangeTopControls = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    this.setState({
      searchText: value
    });
  };
  
  handleAddButtonClick = (event) => {
    if(this.addItemInput) {
      this.addItemInput.focus();
    }
  };

  // Old eye icon handler, now showAllTextInObjects == true is the default behaviour
  // handleShowAllTextInObjectsClick = (event) => {
  //   this.setState({
  //     showAllTextInObjects: !this.state.showAllTextInObjects
  //   });
  // }

  render() {
    const {
      className,
      values,
      options,
      onChange,
      labelLocale,
      addSelectLocale,
      searchSelectLocale,
      noMoreOptionsLocale,
      additionalControls,
      valueAccesor,
      labelAccesor,
      handleSelectBiTemplatesPopup,
      hideList,
      disabled,
      connector,
    } = this.props;
    const dataPath = this.props["data-path"];
    let valuesMap = {};
    let noOptionsLeft = false;
    return (
      <div className={"custom-input free-text-list select-list" + (className ? " " + className : "") + (!searchSelectLocale ? " select-list-no-search" : "") + (values.length>0 ? "": " bi_templates_filter_empty")}>
        <div className="free-text-list-eye-icon">
        </div>
        {!hideList && (
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
              return (
                <div key={i} className={"free-text-list-list-item" + (this.state.showAllTextInObjects ? " show_object_full_text" : "")}>
                  <div className="free-text-list-list-item-inner" title={item[this.props.labelAccesor]}>{item[this.props.labelAccesor]}</div>
                  {!disabled && (
                    <div className="free-text-list-list-item-action-buttons">
                      <i 
                        className="fas edit-action fa-edit"                          
                        data-index={i}
                        data-edit={"edit"}
                        data-selectlist={"true"}
                        data-path={dataPath}
                        onClick={onChange}
                      />
                      <i 
                        className="fas delete-action fa-trash"                          
                        data-index={i}
                        data-delete={"true"}
                        data-selectlist={"true"}
                        data-path={dataPath}
                        onClick={onChange}
                      />
                    </div>
                  )}
                </div>
              );           
            })}
          </div>
        )}
      </div>
    );
  }
}

export default BiTemplatesDataObject;



// WEBPACK FOOTER //
// ./source/client/components/exportConfigurationsAdmin/biTemplatesDataObject.jsx